import { createAction, props } from '@ngrx/store';

export const LoadCheckbookDetailsCols = createAction(
  '[Search Checkbooks: Checkbook Details]:Load Checkbook Details Columns',
  props<{ displayedColumns: { [label: string]: string } }>(),
);

export const IdToolTipChanged = createAction(
  '[Search Checkbooks: Checkbook Details]: Id Tool Tip Changed',
  props<{ idOfTooltip: number | null }>(),
);

export const UpdateToolTipText = createAction(
  '[Search Checkbooks: Checkbook Details]: Update ToolTip Text',
  props<{ toolTipText: string }>(),
);
